import {Viewer} from '../../../state/viewer/types';
import {Queue} from '../Queues/queueUtil';
import {WANDB_ENTITY_NAME, WANDB_PUBLIC_QUEUE_NAME} from '../utils';

export const viewerCanSeePublicQueueAdminTabs = (viewer?: Viewer) => {
  return viewer && viewer.admin && viewer.entity === WANDB_ENTITY_NAME;
};

export const isPublicQueue = (queue: Queue) => {
  return (
    queue.name === WANDB_PUBLIC_QUEUE_NAME &&
    queue.entityName === WANDB_ENTITY_NAME
  );
};
